import { defineMessages } from "react-intl";

const messages = defineMessages({
    forming: {
        id: "choir.meta.details.status.forming",
        defaultMessage: "Forming"
    },
    operating: {
        id: "choir.meta.details.status.operating",
        defaultMessage: "Operating"
    },
    suspended: {
        id: "choir.meta.details.status.suspended",
        defaultMessage: "Suspended"
    },
    disbanded: {
        id: "choir.meta.details.status.disbanded",
        defaultMessage: "Disbanded"
    },

    weekly: {
        id: "choir.meta.details.concertFrequency.weekly",
        defaultMessage: "Weekly"
    },
    monthly: {
        id: "choir.meta.details.concertFrequency.monthly",
        defaultMessage: "Monthly"
    },
    everyTwoMonths: {
        id: "choir.meta.details.concertFrequency.everyTwoMonths",
        defaultMessage: "Every two months"
    },
    everyThreeMonths: {
        id: "choir.meta.details.concertFrequency.everyThreeMonths",
        defaultMessage: "Every three months"
    },
    everyHalfAYear: {
        id: "choir.meta.details.concertFrequency.everyHalfAYear",
        defaultMessage: "Every half a year"
    },
    annually: {
        id: "choir.meta.details.concertFrequency.annually",
        defaultMessage: "Annually"
    },

    membershipFee: {
        id: "choir.meta.details.fundingModel.membershipFee",
        defaultMessage: "Membership fee"
    },
    donationAssociationSponsored: {
        id: "choir.meta.details.fundingModel.donationAssociationSponsored",
        defaultMessage: "Donation, association, sponsored"
    },
    payment: {
        id: "choir.meta.details.fundingModel.payment",
        defaultMessage: "Payment"
    },

    smallEnsemble: {
        id: "choir.meta.details.choirSize.smallEnsemble",
        defaultMessage: "Small ensemble"
    },
    ensemble: {
        id: "choir.meta.details.choirSize.ensemble",
        defaultMessage: "Ensemble"
    },
    smallChamberChoir: {
        id: "choir.meta.details.choirSize.smallChamberChoir",
        defaultMessage: "Small chamber choir"
    },
    chamberChoir: {
        id: "choir.meta.details.choirSize.chamberChoir",
        defaultMessage: "Chamber choir"
    },
    choir: {
        id: "choir.meta.details.choirSize.choir",
        defaultMessage: "Choir"
    },

    mens: {
        id: "choir.meta.details.type.mens",
        defaultMessage: "Men's"
    },
    womens: {
        id: "choir.meta.details.type.womens",
        defaultMessage: "Women's"
    },
    mixed: {
        id: "choir.meta.details.type.mixed",
        defaultMessage: "Mixed"
    },

    none: {
        id: "choir.meta.details.proficiencyLevel.none",
        defaultMessage: "None"
    },
    basic: {
        id: "choir.meta.details.proficiencyLevel.basic",
        defaultMessage: "Basic"
    },
    intermediate: {
        id: "choir.meta.details.proficiencyLevel.intermediate",
        defaultMessage: "Intermediate"
    },
    intermediateAdvanced: {
        id: "choir.meta.details.proficiencyLevel.intermediateAdvanced",
        defaultMessage: "Intermediate-advanced"
    },
    advanced: {
        id: "choir.meta.details.proficiencyLevel.advanced",
        defaultMessage: "Advanced"
    },

    quietAudience: {
        id: "choir.meta.details.concertConditions.quietAudience",
        defaultMessage: "Quiet audience"
    },
    noisyAudience: {
        id: "choir.meta.details.concertConditions.noisyAudience",
        defaultMessage: "Noisy audience"
    },
    indoor: {
        id: "choir.meta.details.concertConditions.indoor",
        defaultMessage: "Indoor"
    },
    outdoor: {
        id: "choir.meta.details.concertConditions.outdoor",
        defaultMessage: "Outdoor"
    },
    localConcerts: {
        id: "choir.meta.details.concertConditions.localConcerts",
        defaultMessage: "Local concerts"
    },
    frequentTravel: {
        id: "choir.meta.details.concertConditions.frequentTravel",
        defaultMessage: "Frequent travel"
    },

    rehearsal: {
        id: "choir.meta.details.rehearsals.type.rehearsal",
        defaultMessage: "Rehearsal"
    },
    sectional: {
        id: "choir.meta.details.rehearsals.type.sectional",
        defaultMessage: "Sectional"
    },
    tutoring: {
        id: "choir.meta.details.rehearsals.type.tutoring",
        defaultMessage: "Tutoring"
    },
});

export default messages;
